import { Button, Result, Typography } from "antd";
import qs from "query-string";
import { useHistory } from "react-router-dom";
import { LINK_STATE_STORAGE_FIELD } from "./constants";
import { LocalStorageState, useLinkTracker } from "./hooks/useLinkTracker";
import { isCapitalOneGate } from "./LinkComplete";
import { handleClose } from "./utils";
import Store from "./stateStore";
import { captureException } from "./sentry";
import { useEffect } from "react";

const { Paragraph, Text } = Typography;

function LinkError() {
  useLinkTracker({ result: "failure" });
  const history = useHistory();
  const { search } = history.location;
  const parsedSearch = qs.parse(search);

  const store = Store.useStore();

  const { error_message, link_origin, platformName, link_update_id } =
    parsedSearch;

  const capitalOnePassedOrigin =
    localStorage.getItem("parentWindowOrigin") ?? store.get("origin");
  const connectionId =
    localStorage.getItem("rutterItemId") ?? store.get("itemId");

  useEffect(() => {
    if (isCapitalOneGate()) {
      // capital one is special we want to send messages no matter what
      if (window?.opener) {
        try {
          console.info("Emitting message to opener", {
            type: "ERROR",
            connectionid: connectionId,
            origin: capitalOnePassedOrigin,
          });
          window.opener.postMessage(
            JSON.stringify({
              type: "ERROR",
              connectionid: connectionId,
            }),
            capitalOnePassedOrigin,
          );
        } catch (e) {
          captureException(e);
        }
      }
    }
  }, []);

  const handleTryAgain = () => {
    if (link_update_id) {
      history.push(`/connections/${link_update_id}`);
    } else {
      let queryString = "";
      if (isCapitalOneGate()) {
        try {
          const data = localStorage.getItem(LINK_STATE_STORAGE_FIELD);
          if (data) {
            const parsedData = JSON.parse(data) as LocalStorageState;
            const queryParams = {
              token: parsedData.publicKey,
            };

            queryString = `?${qs.stringify(queryParams)}`;
          }
        } catch (error) {
          console.error(error);
        }
      }
      history.push(`/platform${queryString}`);
    }
  };

  let actions: any = [
    <Button key="buy" onClick={handleClose}>
      Close window
    </Button>,
  ];
  if (link_origin) {
    actions = [
      <Button type="primary" key="console" onClick={handleTryAgain}>
        Try again
      </Button>,
      ...actions,
    ];
  }
  if (isCapitalOneGate()) {
    return (
      <div
        style={{ fontFamily: "Optimist" }}
        className="grid grid-rows-[20px_1fr_20px] items-center justify-items-center min-h-screen p-8 pb-20 gap-16 sm:p-20 ">
        <main className="flex flex-col gap-8 row-start-2 items-center sm:items-start">
          {/* RUTTER CODE START ============== */}
          <div
            style={{ padding: "3.2rem", height: "100%", position: "relative" }}>
            <div className="flex flex-column items-center justify-center pb-4">
              <div className="flex flex-column items-center justify-center pb-4">
                <img
                  style={{ height: 80, marginBottom: 20 }}
                  alt=""
                  src="/capitalone_grv-spot-caution-triangle.svg"></img>
              </div>
            </div>

            <div className="text-xl text-center">
              <div className="text-center text-[24px] ">
                Something went wrong
              </div>
            </div>

            <div className="text-center mt-8 text-[16px]">
              We're having trouble signing you in right now, but you can retry
              the connection. If you are still unable to connect, close this
              window and notify a Capital One representative.
            </div>

            <div className="mt-8 "></div>

            <div
              style={{
                marginTop: "12px",
                marginBottom: ".8rem",
                marginRight: ".8rem",
                marginLeft: ".8rem",
              }}
              className="">
              <div className="flex items-center justify-center flex-col ">
                <a href="" rel="noopener noreferrer">
                  <button
                    onClick={handleTryAgain}
                    className="max-w-sm rounded-md transition-colors bg-[#0070A8] hover:bg-[#015884] hover:border-transparent text-sm sm:text-base h-10 sm:h-12 px-24 sm:px-24 cursor-pointer">
                    <span className="text-white font-semibold ">
                      Retry connection
                    </span>
                  </button>
                </a>

                <p className="mt-3 max-w-sm text-center ">
                  <span
                    onClick={handleClose}
                    className="text-[#0070A8] font-semibold cursor-pointer">
                    Close this window
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="flex gap-4 items-center flex-col sm:flex-row"></div>
        </main>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 99,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <Result
        status="error"
        title="Authentication Error"
        subTitle={
          "We encountered an error, but your information & credentials are secure."
        }
        extra={actions}>
        <div className="desc">
          <Paragraph>
            <Text
              strong
              style={{
                fontSize: 16,
              }}>
              Here's what we know:
            </Text>
          </Paragraph>
          <Paragraph>{error_message}</Paragraph>
        </div>
      </Result>
    </div>
  );
}

export default LinkError;
